import React from 'react'
import { useSelector } from 'react-redux'

import { CALL_TO_ACTION } from '../../../fields'

import { adSelector } from '../../../../../../modules/selectors/ads'
import tikTokCallToActionsList from '../../../../../../constants/selectLists/tikTokCallToActionsList'

const CTASectionPreview = () => {
  const ad = useSelector(adSelector)

  const { [CALL_TO_ACTION]: cta } = ad
  const ctaLabel = tikTokCallToActionsList.find(({ value }) => value === cta)?.label

  return <p>{ctaLabel}</p>
}

export default CTASectionPreview
